import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../../ui/alert-dialog';

export function RemoveMemberDialog({ member, removing, onConfirm, onClose }) {
  return (
    <AlertDialog open={!!member} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="remove-member-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Remove {member?.name} from the family?</AlertDialogTitle>
          <AlertDialogDescription>
            They will no longer see this family's pages, events, photos, vault or chat, and any family roles they hold are removed.
            Things they already posted stay. You can add them back later.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="remove-member-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            disabled={removing}
            className="bg-red-600 hover:bg-red-700"
            data-testid="remove-member-confirm"
          >
            {removing ? 'Removing...' : 'Remove from family'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
